import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../logo.png';
import NotificationBell from './NotificationBell';

const PAGE_TITLES = [
  { match: /^\/(dashboard|home)?$/, title: 'Dashboard' },
  { match: /^\/companies|^\/addcompany/, title: 'Company' },
  { match: /^\/main-companies/, title: 'Main Companies' },
  { match: /^\/providers|^\/addprovider/, title: 'Providers' },
  { match: /^\/services|^\/addservice/, title: 'Services' },
  { match: /^\/roles/, title: 'Roles' },
  { match: /^\/logs?$/, title: 'Logs' },
  { match: /^\/audit-logs/, title: 'Audit Logs' },
  { match: /^\/analytics/, title: 'Verification Log' },
  { match: /^\/dailystats/, title: 'Daily Stats' },
  { match: /^\/api-usage/, title: 'API Usage' },
  { match: /^\/notifications/, title: 'Notifications' },
  { match: /^\/opportunities/, title: 'Feature Opportunities' },
];

function getPageTitle(pathname) {
  const found = PAGE_TITLES.find((entry) => entry.match.test(pathname));
  return found ? found.title : 'Secure Identity Verification';
}

function TopNavBar({ toggleSidebar, theme, toggleTheme, sidebarCollapsed, toggleCollapsed }) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!auth) return null;

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const pageTitle = getPageTitle(location.pathname);
  const displayName = auth.companyName || 'Secure IVS';

  return (
    <nav className="navbar col-lg-12 col-12 p-0 d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <NavLink className="navbar-brand brand-logo mr-5 ivs-sidebar-brand" to="/dashboard">
          <img src={Logo} alt="logo" />
          {/* <span className="ivs-sidebar-brand__text">Secure Identity<br />Verification</span> */}
        </NavLink>
        <NavLink className="navbar-brand brand-logo-mini" to="/dashboard">
          <img className="main-logo" src={Logo} alt="logo" />
        </NavLink>
      </div>

      <div className="navbar-menu-wrapper d-flex align-items-center justify-content-between flex-grow-1 px-3">
        <div className="d-flex align-items-center" style={{ gap: 14 }}>
          <button
            type="button"
            onClick={toggleCollapsed}
            className={`ivs-icon-btn d-none d-lg-flex${sidebarCollapsed ? ' is-active' : ''}`}
            aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <i className="bi bi-list"></i>
          </button>
          <h4 className="ivs-topbar__title mb-0">{pageTitle}</h4>
        </div>

        <div className="ivs-topbar__actions">
          <button
            type="button"
            className="ivs-icon-btn"
            onClick={toggleTheme}
            aria-label="Toggle dark mode"
          >
            <i className={`bi ${theme === 'dark' ? 'bi-sun' : 'bi-moon-stars'}`}></i>
          </button>

          <NotificationBell />

          <div className="dropdown">
            <a
              className="ivs-profile dropdown-toggle"
              href="#"
              data-toggle="dropdown"
              id="profileDropdown"
              style={{ textDecoration: 'none' }}
            >
              <div className="ivs-profile__avatar">
                <i className="bi bi-person-fill"></i>
              </div>
              <div className="text-left">
                <div className="ivs-profile__name">{displayName}</div>
                <div className="ivs-profile__role">{auth.role}</div>
              </div>
            </a>
            <div
              className="dropdown-menu dropdown-menu-right navbar-dropdown"
              aria-labelledby="profileDropdown"
            >
              <div className="dropdown-item text-muted" style={{ fontSize: 12 }}>
                <i className="bi bi-person-circle mr-2"></i>
                {auth.companyName || auth.role}
              </div>
              <div className="dropdown-divider"></div>
              <button
                className="dropdown-item text-danger"
                onClick={handleLogout}
                style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
              >
                <i className="ti-power-off mr-2"></i> Sign out
              </button>
            </div>
          </div>

          <button
            onClick={toggleSidebar}
            id="sidebar-open"
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
          >
            <span className="icon-menu"></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default TopNavBar;
